export enum FileUploadMode {
  Dropzone = 'dropzone',
  FileManager = 'filemanager',
}

export enum FileStatus {
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Reading = 'reading',
}
export interface FileItem {
  id: string;
  file: File;
  selected: boolean;
  status: FileStatus;
  downloadUrl?: string;
  errorMessage?: string;
  progress: number;
  isSensitive?: boolean;
  /** Base64 MD5 hash, computed when the file is added to the queue */
  md5Hash?: string;
}

export interface PreviewableFile {
  name: string;
  fileUrl: string;
  id: string;
}
